export default __webpack_public_path__ + "static/media/visibility_black_24dp.463f70d0.svg";